import * as React from "react";
import { forwardRef } from "react";
const SvgIconReplace = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.825 9.1665L2.5 12.4998L5.825 15.8332V13.3332H11.6667V11.6665H5.825V9.1665ZM17.5 7.49984L14.175 4.1665V6.6665H8.33333V8.33317H14.175V10.8332L17.5 7.49984Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgIconReplace);
export { ForwardRef as ReactComponent };
